import Hero from '../../components/Hero/Hero'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import whatIs from '../../assets/img/que-es.png'
import GoalsAndObjectives from './components/GoalsAndObjectives'
import WorkTeam from './components/WorkTeam'
import FAQS from './components/FAQS'
import SEO from '../../components/SEO/SEO'
import CTABox from '../../components/Cards/CTABox'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { useEffect } from 'react'
import { getFAQs } from '../../redux/slices/FAQs/faqsThunk'
import ResponsiveContainer from '../../layouts/ResponsiveContainer'

const Index = () => {
    const dispatch = useAppDispatch();

    const { faqs, loading } = useAppSelector((state) => state.faqs)

    useEffect(() => {
        if (!faqs) {
            dispatch(getFAQs());
        }
    }, [faqs])

    return (
        <>
            <SEO
                title='¿Qué es?'
                description='Información sobre el monitor'
                type='article'
            />
            <Hero
                breadcrumbs={<Breadcrumbs />}
                title='¿Qué es el monitor?'
                paragraph={`El Monitor de Derechos es una plataforma digital creada por la Defensoría del Pueblo de la Ciudad de Buenos Aires, con el objetivo de contribuir al seguimiento de la situación de los derechos civiles, políticos, económicos, sociales, culturales y ambientales en el ámbito porteño, a partir de un conjunto de indicadores que posibilitan el registro de avances y retrocesos`}
                contentContainerClassName='flex-col mb-[5.25rem]'
                containerHeightClassName='h-full'
                media={{ type: 'image', url: '', src: whatIs, alt: 'que-es-el-monitor', className: 'h-[10.423rem] sm:h-[13.359rem] md:h-[23.75rem] object-fit max-w-none mt-1' }}
                layout='column'
                titleClassName='text-brand-green-20'
                backgroundClassName={{ backgroundColor: '#E3DDD8' }}
            />
            <GoalsAndObjectives />
            {
                loading === 'succeeded'
                && <FAQS
                    faqs={faqs ?? []}
                />
            }
            <WorkTeam />
            <div className='flex flex-col items-center bg-brand-baige-10/50 '>
                <ResponsiveContainer className='flex flex-col justify-center'>
                    <CTABox
                        title="¿Tenés dudas o consultas?"
                        linkPath="/monitor/contactanos"
                        buttonLabel="Contactanos"
                        background="bg-brand-baige-20"
                        variant='redesign'
                        classNameContainer='my-16'
                    />
                </ResponsiveContainer>
            </div>
        </>
    )
}

export default Index